import { CountryCode } from 'typescript/constants/localization';
import {
  OrderAddress,
  OrderSummaryCartSummary,
} from 'typescript/types/api/solidshop';

// TODO: migrate these constants to a typescript file
import { PO_BOX_REGEX_BY_COUNTRY } from 'constants/patterns';
import { isFeatureEnabled, PO_BOX_BLOCKED } from 'utilities/features';

/**
 * Checks if the address is a PO Box address
 * @param countryCode - CountryCode
 * @param address - OrderAddress
 * @returns boolean
 */
export const isPOBoxAddress = ({
  countryCode,
  address = {} as OrderAddress,
}: {
  countryCode: CountryCode;
  address: OrderAddress;
}) => {
  // TODO: potentially might need to add in a check for if the country needs the check or not
  // see: features.js isFeatureEnabled(PO_BOX_CHECK, countryCode), and how it's implemented in information.jsx
  const pattern =
    PO_BOX_REGEX_BY_COUNTRY[countryCode] || PO_BOX_REGEX_BY_COUNTRY.DEFAULT;
  const regex = new RegExp(pattern, 'gim');

  // our solidshop api returns the address object with an additional 'editable' key
  // that is a boolean which we cannot run through the regex test
  return Object.values(address)?.some(
    (line) => typeof line === 'string' && regex.test(line),
  );
};

/**
 * Checks if PO Box is blocked for the country or any of the line items
 * @param countryCode - CountryCode
 * @param lineItems - OrderSummaryCartSummary[]
 * @returns boolean
 */
export const isPOBoxBlocked = ({
  countryCode,
  lineItems = [],
}: {
  countryCode: CountryCode;
  lineItems: OrderSummaryCartSummary[];
}) => {
  const disabledForCountry = isFeatureEnabled(PO_BOX_BLOCKED, countryCode);
  const disabledForLineItems = lineItems?.some((item) => !item.pobox_eligible);

  return disabledForCountry || disabledForLineItems;
};

/**
 * Returns line items that block PO Box
 * @param lineItems - OrderSummaryCartSummary[]
 * @returns OrderSummaryCartSummary[] - line items that block PO Box
 */
export const lineItemsBlockingPOBox = (
  lineItems: OrderSummaryCartSummary[] = [],
) => {
  return lineItems?.filter((item) => !item.pobox_eligible);
};
